if (!customElements.get("product-recommendations")){
  class ProductRecommendations extends HTMLElement {
    observer = undefined;

    constructor() {
      super();
    }

    connectedCallback() {
      this.initializeRecommendations(this.dataset.productId);
    }

    initializeRecommendations(productId) {
      this.observer?.unobserve(this);
      this.observer = new IntersectionObserver(
        (entries, observer) => {
          if (!entries[0].isIntersecting) return;
          observer.unobserve(this);
          this.loadRecommendations(productId);
        },
        { rootMargin: "0px 0px 400px 0px" }
      );
      this.observer.observe(this);
    }

    loadRecommendations(productId) {
      const query = `&product_id=${productId}&section_id=${this.dataset.sectionId}`;
      const brandUrl = this.dataset.urlBrand;
      Promise.all([
        fetch(`${this.dataset.url}${query}`).then((response) => response.text()),
        brandUrl ? fetch(`${brandUrl}${query}`).then((response) => response.text()).catch(() => "") : "",
      ])
        .then(([text, brandText]) => {
          const html = document.createElement("div");
          html.innerHTML = text;
          const recommendations = html.querySelector("product-recommendations");

          if (recommendations?.innerHTML.trim().length) {
            this.innerHTML = recommendations.innerHTML;
            const brandHtml = document.createElement("div");
            brandHtml.innerHTML = brandText;
            this.sortSameSize(productId, [...brandHtml.querySelectorAll("li[data-product-id]")]);
          }

          if (this.classList.contains("complementary-products")) {
            this.remove();
          }

          if (html.querySelector(".grid__item")) {
            this.classList.add("product-recommendations--loaded");
          }
        })
        .catch((e) => {
          console.error(e);
        });
    }

    // Anvelope de aceeasi dimensiune: fara produsul curent, acelasi brand primul (ordinea de pret ramane).
    // brandItems = aceeasi dimensiune + acelasi brand, din data-url-brand.
    sortSameSize(productId, brandItems = []) {
      const grid = this.querySelector("ul[data-products-to-show]");
      const items = [...this.querySelectorAll("li[data-product-id]")];
      if (!grid || !items.length) return;
      const vendor = this.dataset.vendor;
      const seen = new Set([String(productId)]);
      const kept = [...brandItems, ...items].filter((li) => !seen.has(li.dataset.productId) && seen.add(li.dataset.productId));
      const sorted = [...kept.filter((li) => li.dataset.vendor === vendor), ...kept.filter((li) => li.dataset.vendor !== vendor)];
      const limit = parseInt(grid.dataset.productsToShow, 10) || 4;
      items.forEach((li) => li.remove());
      sorted.slice(0, limit).forEach((li) => grid.appendChild(li));
    }
  }
  
  customElements.define("product-recommendations", ProductRecommendations);
}